import { Fragment, useEffect, useState } from 'react';
import _ from 'lodash';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { Box, Card, Checkbox, Stack, Typography } from '@mui/material';
import { fieldType } from 'components/FormCreator/types';
import TextArea from 'components/FormCreatorComponent/inputs/TextArea';
import { fieldMode } from 'components/FormCreatorComponent/types';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { ButtonComponent } from 'components/ButtonComponent';
import { approveAllSteps } from 'services/new_accounts.service';
import { getNewAccount } from 'state/reducers/new_accounts.reducers';
import { FormCard, FormCardSingleColumnLayout } from 'theme/elements/Forms';
import { hasPermission } from 'components/AuthorizationComponent';
import { permissionEnums } from 'constants/permission.constants';

export interface IFinalApprove {
	handleBack?: any;
}
export const FinalApprove = ({ handleBack }: IFinalApprove) => {
	const dispatch = useAppDispatch();
	const newAccount = useAppSelector(getNewAccount);
	const [BoNotes, setBoNotes] = useState<string | null>(null);
	const [openRejectExplanation, setOpenRejectExplanation] = useState<boolean>(false);
	const t = useAppSelector(selectTranslations);
	const [checked, setChecked] = useState(false);
	const approveAccountPermission = hasPermission([permissionEnums.APPROVE_ACCOUNT]);

	const handleApproveAccount = () => {
		if (approveAccountPermission) {
			dispatch(approveAllSteps(newAccount?.id));
		}
	};
	const handleReject = () => {
		if (approveAccountPermission) {
			dispatch(approveAllSteps(newAccount?.id, BoNotes));
		}
	};

	return (
		<Fragment>
			{!openRejectExplanation && (
				<FormCardSingleColumnLayout>
					<FormCard title={t('page.accounts.new_account.final_agreement.title')}>
						<Stack
							flexDirection={'row'}
							alignItems={'center'}
							alignContent={'center'}
							sx={{ border: '1px solid #C7E5DE', borderRadius: '4px', padding: '12px' }}
						>
							<Checkbox checked={checked} onClick={() => setChecked(!checked)} />
							<Box>
								<Typography variant="subtitleBold" color={'#12564F'}>
									{t('page.accounts.new_account.final_agreement.subtitle')}
								</Typography>
								<Typography>{t('page.accounts.new_account.final_agreement.info')}</Typography>
							</Box>
						</Stack>
					</FormCard>
				</FormCardSingleColumnLayout>
			)}
			{openRejectExplanation && (
				<FormCardSingleColumnLayout>
					<FormCard title={t('label.rejectQuestionTitle')}>
						<Typography>{t('label.rejectQuestionSubtitle')}</Typography>
						<TextArea
							valid={_.isNull(BoNotes) || BoNotes !== ''}
							cField={{
								type: fieldType.text,
								mode: fieldMode.readWithEnableWrite,
								props: {
									name: 'bo_notes',
									label: '',
									required: true,
									value: BoNotes === null ? '' : BoNotes,
								},
								validation: [{ requierd: true }],
							}}
							handleChange={(e) => {
								setBoNotes(e.target.value);
							}}
							initialValidation={[]}
						></TextArea>
					</FormCard>
				</FormCardSingleColumnLayout>
			)}
			<Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '3rem' }}>
				<ButtonComponent
					variantType="text"
					disabled={false}
					handleClick={handleBack}
					text={`<${t('label.back')}`}
					styleObj={{ borderRadius: '8px', width: '30%', height: '48px' }}
				/>
				{!openRejectExplanation && (
					<>
						<ButtonComponent
							disabled={false}
							variantType="outlined"
							handleClick={() => setOpenRejectExplanation(true)}
							text={`${t('page.accounts.new_account.final_agreement.btn.send_to_check')}`}
							styleObj={{ borderRadius: '8px', width: '30%', height: '48px' }}
						/>
						<ButtonComponent
							disabled={!checked}
							handleClick={handleApproveAccount}
							text={`${t('page.accounts.new_account.final_agreement.btn.approve')}`}
							styleObj={{ borderRadius: '8px', width: '30%', height: '48px' }}
						/>
					</>
				)}
				{openRejectExplanation && (
					<ButtonComponent
						disabled={_.isNil(BoNotes) || _.isEmpty(BoNotes)}
						handleClick={handleReject}
						text={`${t('page.accounts.new_account.final_agreement.btn.send')}`}
						styleObj={{ borderRadius: '8px', width: '30%', height: '48px' }}
					/>
				)}
			</Box>
		</Fragment>
	);
};
